export class Servers {
    static TEST = 'test';
    static USA = 'usa';
    static ASIA = 'asia';
    static LONDON = 'london';
    static BACK = 'back';
}

export const urls:any = {};
urls[Servers.TEST] = "https://uandisync-london.com";
urls[Servers.USA] = "https://uandisync-london.com";
urls[Servers.ASIA] = "https://uandisync-london.com";
urls[Servers.LONDON] = "https://uandisync-london.com";
urls[Servers.BACK] = "https://uandisync-london.com";

export const defaultServer:string = Servers.USA;

